// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-670816e9] .el-divider{margin-top:12px}", "",{"version":3,"sources":["webpack://./resources/js/views/admin/Dashboard.vue"],"names":[],"mappings":"AACA,8BACE,eAAF","sourcesContent":["\r\n::v-deep(.el-divider) {\r\n  margin-top: 12px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
